import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function Backdrop({ children, className = 'bg-black/40 backdrop-blur-sm' }) {
    return (_jsx("div", { className: classNames('z-overlay fixed inset-0 flex items-center justify-center', className), children: _jsx("div", { children: children }) }));
}
